export { default } from './Entrance'
